/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const ArrowRight = (props: any) => (
<svg {...props}   viewBox="0 0 32 32" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="32px/arrow-right">
<path id="Arrow 4" d="M6 15C5.44772 15 5 15.4477 5 16C5 16.5523 5.44772 17 6 17L6 15ZM26.7071 16.7071C27.0976 16.3166 27.0976 15.6834 26.7071 15.2929L20.3431 8.92893C19.9526 8.53841 19.3195 8.53841 18.9289 8.92893C18.5384 9.31946 18.5384 9.95262 18.9289 10.3431L24.5858 16L18.9289 21.6569C18.5384 22.0474 18.5384 22.6805 18.9289 23.0711C19.3195 23.4616 19.9526 23.4616 20.3431 23.0711L26.7071 16.7071ZM6 17L26 17L26 15L6 15L6 17Z" fill="#282828"/>
</g>
</svg>
);

export default ArrowRight;